import { nextAPI } from './Axios'

export const API = {
    getVerify(data) {
        return nextAPI.post('verification', data)
    },

    async login(data) {
        return await nextAPI.post('login', data)
    },

    async olcLogin(data) {
        return await nextAPI.post('olc-login', data)
    },

    async resetPass(data) {
        return await nextAPI.post('reset-password', data)
    },

    async forgotPassword(data) {
        return await nextAPI.post('forgot-password', data)
    },

    async createPaymentIntent(data) {
        return await nextAPI.post('payment-intent', data)
    },

    async retrievePaymentIntent(payment_intent_id) {
        return await nextAPI.post('payment-intent', {
            action: 'retrieve',
            payment_intent_id,
        })
    },

    async fetchExistingCards(data) {
        return await nextAPI.post('fetch-cards', data)
    },

    async deleteStripeCard(id) {
        return await nextAPI.delete(`delete-card/${id}`)
    },

    async confirmOrder(data) {
        return await nextAPI.put('confirm-order', data)
    },

    async attachCardToCustomer(data) {
        return await nextAPI.post('attach-card', data)
    },

    async getRosOffers(data) {
        return await nextAPI.post('ros-offers', data)
    },

    async createCustomerAccount(data) {
        return await nextAPI.post('create-customer', data)
    },
}
